import KanbansAPI from '../../api/kanbans';

export const SET_KANBAN_MEMBERS_UI_FLAG = 'SET_KANBAN_MEMBERS_UI_FLAG';
export const ADD_AGENTS_TO_KANBAN = 'ADD_AGENTS_TO_KANBAN';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getKanbanMembers: $state => id => {
    return $state.records[id] || [];
  },
};

export const actions = {
  get: async ({ commit }, { kanbanId }) => {
    commit(SET_KANBAN_MEMBERS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await KanbansAPI.getAgents({ kanbanId });
      commit(ADD_AGENTS_TO_KANBAN, { data, kanbanId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_MEMBERS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, { agentsList, kanbanId }) => {
    commit(SET_KANBAN_MEMBERS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await KanbansAPI.addAgents({ agentsList, kanbanId });
      commit(ADD_AGENTS_TO_KANBAN, { kanbanId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_MEMBERS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { agentsList, kanbanId }) => {
    commit(SET_KANBAN_MEMBERS_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await KanbansAPI.updateAgents({
        agentsList,
        kanbanId,
      });
      commit(ADD_AGENTS_TO_KANBAN, { kanbanId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_MEMBERS_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [SET_KANBAN_MEMBERS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [ADD_AGENTS_TO_KANBAN]($state, { data, kanbanId }) {
    $state.records = {
      ...$state.records,
      [kanbanId]: data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
